var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Tên vị trí ")]),_c('b-input',{attrs:{"type":"text","placeholder":"Nhập tên vị trí..."},model:{value:(_vm.entry.position),callback:function ($$v) {_vm.$set(_vm.entry, "position", $$v)},expression:"entry.position"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }